module.exports = __webpack_public_path__ + "static/media/AnovaUI-BoldItalic.de70555d.woff2";